import { useTranslation } from "react-i18next";

// `details` (optional): { reference, lines[] } — a short support reference plus
// shape-only diagnostics, so a user's screenshot carries what's needed to debug
// a crash even when the Sentry event never arrives.
function ErrorRender({ showReload, hint, details }) {
  const { t } = useTranslation();
  const handleReload = () => {
    window.location.reload();
  };

  return (
    <div className="flex-center-vertical error-container">
      <div className="badge pink mt-30">{t("common.errorLoadingContent")}</div>
      {hint && <div className="error-container-hint">{hint}</div>}
      {details && (
        <details className="error-container-details">
          <summary>
            {t("common.errorReference")}: {details.reference}
          </summary>
          <pre>{details.lines.join("\n")}</pre>
        </details>
      )}
      {showReload && (
        <button type="button" className="btn white mt-20" onClick={handleReload}>
          {t("common.reloadApp")}
        </button>
      )}
    </div>
  );
}

export default ErrorRender;
